import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../services/api.service';
import {
  AccountUsageDashboardDto,
  AccountUsageOverLimitDashboardDto
} from '../models/account-usage.model';

export interface GetAccountUsageOptions {
  accountId?: number;
  from?: string;
  to?: string;
}

@Injectable({ providedIn: 'root' })
export class PlanUsageApiService {
  constructor(private readonly api: ApiService) {}

  getAccountUsage(opts: GetAccountUsageOptions = {}): Observable<AccountUsageDashboardDto> {
    return this.api.get<AccountUsageDashboardDto>('dashboard/account-usage', opts);
  }

  getOverLimitAccounts(): Observable<AccountUsageOverLimitDashboardDto> {
    return this.api.get<AccountUsageOverLimitDashboardDto>('dashboard/account-usage/over-limit');
  }
}
